import React, { useEffect } from "react";
import logo from "../../../assets/images/logo.png";
import HeaderLink from "../HeaderLink";
import { Link } from "react-router-dom";
import HeaderSocial from "../HeaderSocial";
import EmailIcon from "../../../assets/icons/EmailIcon";
import PhoneIcon from "../../../assets/icons/PhoneIcon";
import MenuIcon from "../../../assets/icons/MenuIcon";
import { useSelector } from "react-redux";
import ChangeLang from "../ChangeLang";
function Header() {
  const contactData = useSelector(state => state.Data.contactData);
  const langPrefix = useSelector(state => state.Data.langPrefix);
  useEffect(()=>{
    window.addEventListener("scroll", (e)=>{
      const header = document.querySelector("header");
      if(window.scrollY>=150){
        if(header){
          header.style.position = "fixed";
          header.style.top = "0";
        }
      }else{
        if(header){
          header.style.position = "relative";
          header.style.top = "0px";
        }
      }
    })
  },[])
  const onCloseNav = () => {
    const btn = document.querySelector("#navBtn");
    if(btn){
      btn.checked = false
    }
  }
  return (
    <div className="relative z-[1000]">
      {/* <HeaderSocial /> */}
      <input type="checkbox" id="navBtn" className="hidden" />
      <div onClick={()=>onCloseNav()} className="fixed top-0 left-0 w-full h-screen bg-black/20 hidden navBgShadow z-1"></div>
      <header className="h-[100px] flex items-center  shadow shadow-b w-full top-[50px] left-0 z-2 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 ">
        <div className=" w-full container h-full">
          <div className="flex items-center  h-full gap-[30px] max-[1100px]:justify-between max-[1240px]:gap-[10px]">
            <div className="hidden max-[900px]:block">
               <Link to={`/${langPrefix}`} className="relative z-[1]  inline-flex items-center h-full px-[10px] ml-[-2px]">
                <img src={logo} alt="logo" className="h-[74px] w-[170px] min-w-[170px] max-[1240px]:w-[150px] max-[1240px]:h-[65px]" />
              </Link>
            </div>
        
            <div className="resp-nav justify-between  flex items-center  max-[1240px]:gap-[10px] flex-1">
              <Link to={`/${langPrefix}`} className="relative z-[1] inline-flex  max-[900px]:hidden items-center h-full px-[10px] ml-[-2px]">
                <img src={logo} alt="logo" className="h-[74px] w-[170px] min-w-[170px] max-[1240px]:w-[150px] max-[1240px]:h-[65px]" />
              </Link>
              <HeaderLink />
            
              <div className="flex items-center gap-[20px]">
                {/* <ChangeLang /> */}
              <div className="flex items-start justify-center flex-col ">
                <a href={`mailto:${contactData?.email}`} className="flex items-center gap-[7px]">
                  <span className="inline-flex w-[35px] h-[35px] justify-center items-center rounded-full ">
                    <EmailIcon />
                  </span>
                  <span className="font-[600] text-[16px] max-[1240px]:text-[13px] text-white">{contactData?.email}</span>
                </a>
                <a href={`tel:${contactData?.phone_1}`} className="flex items-center gap-[7px]">
                  <span className="inline-flex w-[35px] h-[35px] justify-center items-center rounded-full ">
                    <PhoneIcon color="#fff" />
                  </span>
                  <span className="font-[600] text-[16px] max-[1240px]:text-[13px] text-white">{contactData?.phone_1}</span>
                </a>
              </div>
              </div>
            </div>
            <label htmlFor="navBtn" className="hidden max-[1100px]:inline-block mr-[20px]">
              <MenuIcon />
            </label>
          </div>
        </div>
      </header>
    
    </div>
   
  );
}

export default Header;
